<template>
    <div class="setting-container">
        <div class="arrow"></div>
        <div class="setting-view">
            <div class="setting-row">
                <div class="item-title">
                    <p>Màu Nền</p>
                </div>
                <div class="item-content">
                    <vue-dropdown :config="colorConfig" @setSelectedOption="colorSelected($event)"></vue-dropdown>
                </div>
            </div>
            <div class="setting-row">
                <div class="item-title">
                    <p>Font Chữ</p>
                </div>
                <div class="item-content">
                    <vue-dropdown :config="config" @setSelectedOption="fontSelected($event)"></vue-dropdown>
                </div>
            </div>
            <div class="setting-row">
                <div class="item-title">
                    <p>Cỡ Chữ</p>
                </div>
                <div class="item-content">
                    <button @click="minusButtonClicked('fontSize')"><font-awesome-icon icon="minus"/></button>
                    <p>{{ fontSize }}</p>
                    <button @click="plusButtonClicked('fontSize')"><font-awesome-icon icon="plus"/></button>
                </div>
            </div>
            <div class="setting-row">
                <div class="item-title">
                    <p>Giãn Dòng</p>
                </div>
                <div class="item-content">
                    <button @click="minusButtonClicked('lineHeight')"><font-awesome-icon icon="minus"/></button>
                    <p>{{ lineHeight }}</p>
                    <button @click="plusButtonClicked('lineHeight')"><font-awesome-icon icon="plus"/></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueDropdown from 'vue-dynamic-dropdown'

    export default {
        props: {
            fontSize: null,
            lineHeight: null,
            fontFamily: null,
            backgroundColor: null
        },
        data() {
            return {
                config: {
                    options: [
                        {
                            value: "Helvetica",
                            cssId: "'Helvetica', sans-serif"
                        },
                        {
                            value: "IBM Plex Serif",
                            cssId: "'IBM Plex Serif', serif"
                        },
                        {
                            value: "Lora",
                            cssId: "'Lora', serif"
                        },
                        {
                            value: "Noto Serif",
                            cssId: "'Noto Serif', serif"
                        },
                        {
                            value: "Open Sans",
                            cssId: "'Open Sans', sans-serif"
                        },
                        {
                            value: "Roboto",
                            cssId: "'Roboto', sans-serif"
                        }
                    ],
                    prefix: this.fontFamily,
                    backgroundColor: "transparent"
                },
                colorConfig: {
                    options: [
                        {
                            value: "Trắng",
                            cssId: "#FFF"
                        },
                        {
                            value: "Vàng",
                            cssId: "#F4ECD8"
                        },
                        {
                            value: "Đen",
                            cssId: "#000"
                        },
                    ],
                    prefix: this.backgroundColor,
                    backgroundColor: "transparent"
                }
            }
        },
        components: { VueDropdown },
        methods: {
            minusButtonClicked(name) {
                this.$emit('minusButtonClicked', name)
            },
            plusButtonClicked(name) {
                this.$emit('plusButtonClicked', name)
            },
            fontSelected(event) {
                this.config.prefix = event.value
                this.$emit('fontSelected', event)
            },
            colorSelected(event) {
                this.colorConfig.prefix = event.value
                this.$emit('colorSelected', event)
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../styles/components/setting-view.scss";
</style>